<template>
  <div class="Home" style="background-color:Lavender;">
    <b-container>
      <br />
      <b-jumbotron
        class="text-md-left text-sm-center"
        bg-variant="secondary"
        text-variant="white"
        border-variant="dark"
      >
        <template v-slot:header>
          <b-img height="150" :src="require('../assets/company-logos/transparent-logo.png')"></b-img>
        </template>
        <br />
        <h5 style="font-style: italic">{{resume.headline}}</h5>
      </b-jumbotron>

      <hr class="my-4 linebreak" />
    </b-container>

    <b-container>
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="6000"
        controls
        indicators
        background="#ababab"
        img-width="40"
        max-height="100"
        style="text-shadow: 1px 1px 2px #333;"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide :img-src="require('../assets/carousel/kitchen_01.png')" img-height="50"></b-carousel-slide>
        <b-carousel-slide :img-src="require('../assets/carousel/kitchen_02.png')" img-height="50"></b-carousel-slide>
        <b-carousel-slide :img-src="require('../assets/carousel/kitchen_03.png')" img-height="50"></b-carousel-slide>
      </b-carousel>

      <hr class="my-4 linebreak" />
    </b-container>

    <b-container class="text-left">
      <b-card bg-variant="secondary" text-variant="white" border-variant="dark">
        <h1>Mission</h1>
        <div v-for="(item, index) in resume.mission" :key="index">
          <h5>{{item}}</h5>
        </div>
      </b-card>

      <hr class="my-4 linebreak" />
      <b-card bg-variant="secondary" text-variant="white" border-variant="dark">
        <h1>Contact</h1>
        <div v-for="(item, index) in resume.values" :key="index">
          <h5>{{item}}</h5>
        </div>
        <h5>Phone - (617) 733-1613</h5>
        <h5>
          Email -
          <a href="mailto:clroumeliotis@gmail.com">clroumeliotis@gmail.com</a>
        </h5>
      </b-card>
    </b-container>

    <br />
  </div>
</template>

<script>
import resume from "js-yaml-loader!../data/resume.yaml";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      resume: resume.about,
    };
  },
};
</script>

<style scoped>
.linebreak {
  background-color: #ccc;
}

.icon {
  margin: 1em;
}

@media screen and (max-width: 640px) {
  .test {
    text-align: center;
  }
}
ul {
  list-style-type: circle;
}
</style>

